import { render, staticRenderFns } from "./MyRemindTask.vue?vue&type=template&id=2783512c&scoped=true&"
import script from "./MyRemindTask.vue?vue&type=script&lang=js&"
export * from "./MyRemindTask.vue?vue&type=script&lang=js&"
import style0 from "./MyRemindTask.vue?vue&type=style&index=0&id=2783512c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2783512c",
  null
  
)

export default component.exports